// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DataHolder, DataHolderT, verifyDataHolder } from "./data-holder";
import { NodeId, NodeIdT, verifyNodeId } from "./node-id";

/**
 * Invoke an OPC UA method on an object with the given input arguments.
 */
export class MethodCall implements flatbuffers.IUnpackableObject<MethodCallT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MethodCall {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMethodCall(bb: flatbuffers.ByteBuffer, obj?: MethodCall): MethodCall {
    return (obj || new MethodCall()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsMethodCall(bb: flatbuffers.ByteBuffer, obj?: MethodCall): MethodCall {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MethodCall()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  /**
   * Object node owning the method.
   */
  objectId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Method node to invoke.
   */
  methodId(obj?: NodeId): NodeId | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new NodeId()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Input argument values, in declaration order.
   */
  inputArguments(index: number, obj?: DataHolder): DataHolder | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new DataHolder()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  inputArgumentsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startMethodCall(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addObjectId(builder: flatbuffers.Builder, objectIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, objectIdOffset, 0);
  }

  static addMethodId(builder: flatbuffers.Builder, methodIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, methodIdOffset, 0);
  }

  static addInputArguments(builder: flatbuffers.Builder, inputArgumentsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, inputArgumentsOffset, 0);
  }

  static createInputArgumentsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startInputArgumentsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endMethodCall(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // object_id
    builder.requiredField(offset, 6); // method_id
    return offset;
  }

  unpack(): MethodCallT {
    return new MethodCallT(
      this.objectId() !== null ? this.objectId()!.unpack() : null,
      this.methodId() !== null ? this.methodId()!.unpack() : null,
      this.bb!.createObjList<DataHolder, DataHolderT>(
        this.inputArguments.bind(this),
        this.inputArgumentsLength(),
      ),
    );
  }

  unpackTo(_o: MethodCallT): void {
    _o.objectId = this.objectId() !== null ? this.objectId()!.unpack() : null;
    _o.methodId = this.methodId() !== null ? this.methodId()!.unpack() : null;
    _o.inputArguments = this.bb!.createObjList<DataHolder, DataHolderT>(
      this.inputArguments.bind(this),
      this.inputArgumentsLength(),
    );
  }

  unpackFields(...fields: string[]): MethodCallT {
    const t = new MethodCallT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("object_id")) {
      t.objectId = this.objectId() !== null ? this.objectId()!.unpack() : null;
    }
    if (fieldSet.has("method_id")) {
      t.methodId = this.methodId() !== null ? this.methodId()!.unpack() : null;
    }
    if (fieldSet.has("input_arguments")) {
      t.inputArguments = this.bb!.createObjList<DataHolder, DataHolderT>(
        this.inputArguments.bind(this),
        this.inputArgumentsLength(),
      );
    }
    return t;
  }
}

export class MethodCallT implements flatbuffers.IGeneratedObject {
  constructor(
    public objectId: NodeIdT | null = null,
    public methodId: NodeIdT | null = null,
    public inputArguments: DataHolderT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.objectId === null || this.objectId === undefined) {
      throw new Error('Required field "object_id" is not set');
    }
    if (this.methodId === null || this.methodId === undefined) {
      throw new Error('Required field "method_id" is not set');
    }
    const objectId = this.objectId !== null ? this.objectId!.pack(builder) : 0;
    const methodId = this.methodId !== null ? this.methodId!.pack(builder) : 0;
    const inputArguments = MethodCall.createInputArgumentsVector(
      builder,
      builder.createObjectOffsetList(this.inputArguments),
    );

    MethodCall.startMethodCall(builder);
    MethodCall.addObjectId(builder, objectId);
    MethodCall.addMethodId(builder, methodId);
    MethodCall.addInputArguments(builder, inputArguments);

    return MethodCall.endMethodCall(builder);
  }

  clone(): MethodCallT {
    const obj = new MethodCallT();
    obj.objectId = this.objectId !== null ? this.objectId!.clone() : null;
    obj.methodId = this.methodId !== null ? this.methodId!.clone() : null;
    obj.inputArguments = this.inputArguments.map((e) => e.clone());
    return obj;
  }

  equals(other: MethodCallT): boolean {
    if (this.objectId !== null && other.objectId !== null) {
      if (!this.objectId!.equals(other.objectId!)) return false;
    } else if (this.objectId !== other.objectId) return false;
    if (this.methodId !== null && other.methodId !== null) {
      if (!this.methodId!.equals(other.methodId!)) return false;
    } else if (this.methodId !== other.methodId) return false;
    if (this.inputArguments.length !== other.inputArguments.length) return false;
    for (let i = 0; i < this.inputArguments.length; i++) {
      const a = this.inputArguments[i];
      const b = other.inputArguments[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyMethodCall(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "object_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyNodeId(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "method_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyDataHolder);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
